import axios from "axios";

const request = axios.create({
  baseURL: "https://totem-api.wmisolutions.online",
});

export default request;
